export const BOLETO_EMAIL_LOG_PREFIX = "[BOLETO EMAIL]";

export const BOLETO_EMAIL_NO_RECIPIENT_MESSAGE =
  "Não foi encontrado um e-mail cadastrado para este cliente. Verifique o cadastro antes de enviar o boleto.";

export function isUsableEmail(value) {
  const email = String(value ?? "").trim();
  if (!email) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

export function extractShipperFinancialContacts(shipperData) {
  const contacts = Array.isArray(shipperData?.contact)
    ? shipperData.contact
    : [];

  return contacts
    .filter((contact) => Boolean(contact?.receivesFinancial))
    .map((contact) => ({
      name: String(contact?.nome || contact?.name || "").trim(),
      email: String(contact?.email || "").trim(),
    }))
    .filter((contact) => isUsableEmail(contact.email));
}

export function resolveShipperIdForFinancialEmail({ record, freightData } = {}) {
  const candidates = [
    record?.shipper?.uid,
    freightData?.shipper?.uid,
    record?.uidShipper,
    freightData?.uidShipper,
  ];

  for (const raw of candidates) {
    const value = Array.isArray(raw) ? raw[0] : raw;
    const id = String(value ?? "").trim();
    if (id) return id;
  }

  return "";
}

export function formatFinancialRecipientLabel(contacts) {
  if (!Array.isArray(contacts) || contacts.length === 0) return "";
  return contacts.map((contact) => contact.email).join(", ");
}

export function buildBoletoSendSuccessMessage(recipients) {
  const label = formatFinancialRecipientLabel(recipients);
  if (!label) {
    return "Boleto enviado com sucesso.";
  }
  return `Boleto enviado com sucesso para ${label}.`;
}

export function buildBoletoSendFailureMessage(recipients) {
  const label = formatFinancialRecipientLabel(recipients);
  if (!label) {
    return "Não foi possível enviar o boleto. Tente novamente ou verifique os dados do cliente.";
  }
  return `Não foi possível enviar o boleto para ${label}. Tente novamente ou verifique os dados do cliente.`;
}

export function buildBoletoSendProgressMessage(recipients) {
  const label = formatFinancialRecipientLabel(recipients);
  if (!label) return "Enviando boleto...";
  return `Enviando boleto para ${label}...`;
}

/**
 * Confirmação inequívoca do serviço de e-mail (HTTP 200 não basta sozinho).
 */
export function isEmailDispatchConfirmed(apiResult) {
  if (!apiResult || apiResult.success !== true) return false;

  let data = apiResult.data;
  if (data == null) return false;

  if (typeof data.body === "string" && data.body.trim()) {
    try {
      data = JSON.parse(data.body);
    } catch {
      // Mantém payload original quando body não for JSON.
    }
  }

  if (typeof data !== "object") return false;
  if (data.success === false || data.error) return false;
  if (data.success === true) return true;
  if (data.messageId || data.message_id || data.id) return true;

  const message = String(data.message || data.msg || "").toLowerCase();
  if (/enviad|sent|success|sucesso/.test(message)) return true;

  if (Object.keys(data).length === 0 || data.raw) return false;

  return !data.error;
}

export function logBoletoEmail(step, details = {}) {
  const safe = { ...(details || {}) };

  delete safe.email;
  delete safe.to;
  delete safe.recipients;
  delete safe.html;
  delete safe.attachmentRefs;
  delete safe.url;
  delete safe.downloadUrl;
  delete safe.contacts;

  if (Array.isArray(details?.contacts)) {
    safe.recipientCount = details.contacts.length;
  }

  if (Object.keys(safe).length === 0) {
    console.info(`${BOLETO_EMAIL_LOG_PREFIX} ${step}`);
    return;
  }

  console.info(`${BOLETO_EMAIL_LOG_PREFIX} ${step}`, safe);
}

export function logBoletoEmailError(step, error, details = {}) {
  const safe = { ...(details || {}) };
  delete safe.email;
  delete safe.to;
  delete safe.recipients;
  delete safe.html;
  delete safe.attachmentRefs;

  const technical =
    error?.message ||
    error?.response?.data?.message ||
    error?.code ||
    (typeof error === "string" ? error : "");

  console.error(`${BOLETO_EMAIL_LOG_PREFIX} ${step}`, {
    ...safe,
    technical: String(technical || "").slice(0, 240),
  });
}
